import { Helmet } from 'react-helmet';
import GiagoimfyDetail
  from 'src/components/giagoimfy-detail/GiagoimfyDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import GiagoimfyListToolbar from '../components/giagoimfy-detail/GiagoimfyToolbar';

const Giagoimfy = () => (
  <>
    <Helmet>
      <title>Giá gói mfy</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <GiagoimfyListToolbar />
        <Box sx={{ pt: 3 }}>
          <GiagoimfyDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Giagoimfy;
